// Shared helper functions for row definitions (used by both ML and product types)

export const optionsWithKeys = options => Object.entries(options).map(([key, value]) => ({ key, ...value }));
export const hasEntityDefined = definition => definition.entity != null;
export const hasFilterEntityDefined = definition => definition.filterEntity != null;
export const someOptionIsAllowed = (definition, options) => options.some(option => option.allowedWhen(definition));
export const isOneOfEntity = entities => definition => hasEntityDefined(definition) && entities.includes(definition.entity);
export const isOneOfFilterEntity = entities => definition => hasFilterEntityDefined(definition) && entities.includes(definition.filterEntity);

export const allowedOptions = (definition, options) => optionsWithKeys(options).filter(option => option.allowedWhen(definition));
